// src/components/step1.js
import { useEffect, useRef, useState } from "react";
import { Header } from "../components/headerTypeOne";
import { config1 } from "../config/step1";
import {
  Constants,
  Step1QuestionIdConstants,
} from "../constants/textconstants";
import { Style } from "../styles/step1";
import { SaveAndCont } from "../components/saveandcont";
import { useLocation, useNavigate } from "react-router-dom";
import { RadioControl, SingleSelect, TextDate } from "../helper-functions/utils";
import { setLoader, showToast } from "../store/slices/util";
import { useDispatch, useSelector } from "react-redux";
import {
  getZila, // Renamed from getDistrict
  getUpazila, // Renamed from getSubDistrict
  getTerritoriesByUpazila, // Renamed from getTerritoriesBySubDistrict
  getBibhags, // Renamed from getStates
} from "../helper-functions";
import { ProceedNotification } from "../components/proceedNotify";
import { get, post } from "../config/api";
import { HasLiscence } from "../components/hasLiscence";
import { SaveProgress } from "../components/saveProgress";
import { LoaderFaded } from "../components/loaderfaded";
import { InfoPopUp } from "../components/infoPopuop";
import { API_URL } from "../config/sys";
import { useTranslation } from "../i18n/useTranslation";

export const Step1 = () => {
  const [formData, setFormData] = useState({});
  const data = useLocation();
  const [fieldErrors, setFieldErrors] = useState({});
  const [enabledFields, setEnabledFields] = useState({
    zila: !data.state.isNewUser, // Renamed from district
    upazila: !data.state.isNewUser, // Renamed from subdistrict
    territory: !data.state.isNewUser,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reviewInfo, setReviewInfo] = useState(false);
  const [config, setConfig] = useState(config1);
  const [showSorryPup, setshowSorryPup] = useState(false);
  const [saveProgress, setSaveProgress] = useState(false);
  const Utils = useSelector((state) => state.Utils);
  const [showError, setShowError] = useState(false);
  const [createNewUser, setCreateNewUser] = useState(false);
  const { t, setCurrentLanguage } = useTranslation();

  useEffect(() => {
    dispatch(setLoader(true));
    const fetchData = async () => {
      dispatch(setLoader(true));
      

      const newstate = await localStorage.getItem("createnewuser");
      const mobilenumber = await localStorage.getItem("mobile_number");

      if (newstate === "false") {
        try {
          const customer_id_stored = await localStorage.getItem("customer_id");
          const customer_id = data.state.retailer
            ? data.state.retailer.customer_id
            : customer_id_stored;

          const response = await get(
            `/survey/responses?customer_id=${customer_id}&page_number=page1&user_id=${data.state.userID}&mobile_number=${mobilenumber}`
          ).catch((e) => {
            dispatch(setLoader(false));
          });

          let tempFormData = {};
          config.map((fields) => {
            response.responses.map((responsefield) => {
              if (fields.identifier == responsefield.question_id) {
                tempFormData[fields.identifier] = responsefield.response;
              }
            });
          });
          console.log(tempFormData, 'temporary')
          setFormData(tempFormData);
        } catch (error) {
          dispatch(setLoader(false));
          console.log(error);
        }
      } else {
        dispatch(
          showToast({ toast: true, toastmessage: t("OTP_VERIFIED_SUCCESSFULLY") })
        );
        setTimeout(() => {
          dispatch(showToast({ toast: false, toastmessage: "" }));
        }, 1500);
        setCreateNewUser(true);
      }
      dispatch(setLoader(false));
      setFormData((prev) => ({
        ...prev,
        [Step1QuestionIdConstants.QUESTION_2]: mobilenumber,
      }));
    };
    fetchData();
  }, [data.state, t]);

  useEffect(() => {
    if (data.state.retailer) {
      setFormData((prev) => ({
        ...prev,
        [Step1QuestionIdConstants.QUESTION_5]: data.state.retailer.shop_name,
        [Step1QuestionIdConstants.QUESTION_2]: data.state.retailer.mobile_number,
      }));
    }
  }, [data.state]);

  const handleChange = async (identifier, value) => {
    console.log(identifier, value);

    if (typeof value === "object" && value !== null) {
       dispatch(setLoader(true));
      let newFormDataChanges = {};

      let updatedConfig = [...config];

      if (identifier === Step1QuestionIdConstants.QUESTION_9) {
        // Bibhag (State)
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_9] = value.value; // Store the display value
        newFormDataChanges["bibhag_code"] = value.id; // Store the ID separately

        // Clear dependent fields and their IDs
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_10] = null;
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_11] = null;
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] = null;
        newFormDataChanges["zila_code"] = null;
        newFormDataChanges["upazila_code"] = null;
        newFormDataChanges["territory_code"] = null;


       
        const zilas = await getZila(value.id); // Call getZila
        updatedConfig = updatedConfig.map((item) => {
          if (item.identifier === Step1QuestionIdConstants.QUESTION_10) {
            return {
              ...item,
              options: zilas.map((d) => ({ ...d, value: t(d.value) })),
            };
          }
          return item;
        });
         dispatch(setLoader(false));
        setEnabledFields((prev) => ({
          ...prev,
          zila: true, // Enable Zila
          upazila: false, // Disable Upazila
          territory: false, // Disable Territory
        }));
      } else if (identifier === Step1QuestionIdConstants.QUESTION_10) {
        // Zila (District)
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_10] = value.value; // Store the display value
        newFormDataChanges["zila_code"] = value.id; // Store the ID separately

        // Clear dependent fields and their IDs
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_11] = null;
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] = null;
        newFormDataChanges["upazila_code"] = null;
        newFormDataChanges["territory_code"] = null;


       
        const upazilas = await getUpazila(value.id); // Call getUpazila
        updatedConfig = updatedConfig.map((item) => {
          if (item.identifier === Step1QuestionIdConstants.QUESTION_11) {
            return {
              ...item,
              options: upazilas.map((sd) => ({
                ...sd,
                value: t(sd.value),
              })),
            };
          }
          return item;
        });
         dispatch(setLoader(false));
        setEnabledFields((prev) => ({
          ...prev,
          upazila: true, // Enable Upazila
          territory: false, // Disable Territory
        }));
      } else if (identifier === Step1QuestionIdConstants.QUESTION_11) {
        // Upazila (Sub-District)
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_11] = value.value; // Store the display value
        newFormDataChanges["upazila_code"] = value.id; // Store the ID separately

        // Clear Territory field before fetching new data
        newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] = "";
        newFormDataChanges["territory_code"] = null;

   
        try {
          const territoryData = await getTerritoriesByUpazila(value.id); // Call getTerritoriesByUpazila
          if (territoryData) {
            // Corrected: Use territory_name from the API response
            newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] =
              territoryData.territory_name; // Prefill the territory name
            newFormDataChanges["territory_code"] = territoryData.territory_code; // Store the territory code separately
          } else {
            newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] = ""; // Clear the field
            newFormDataChanges["territory_code"] = null; // Clear the ID
            console.warn("No territory found for the selected upazila.");
          }
        } catch (error) {
          console.error("Error fetching territories:", error);
          newFormDataChanges[Step1QuestionIdConstants.QUESTION_15] = "";
          newFormDataChanges["territory_code"] = null;
        } finally {
          dispatch(setLoader(false));
          setEnabledFields((prev) => ({
            ...prev,
            territory: false, // Set territory field to be disabled/read-only after prefill
          }));
        }
         dispatch(setLoader(false));
      } else {
         dispatch(setLoader(false));
          // For other singleSelects (like Establishment Type, Customer Type, Radio buttons)
          newFormDataChanges[identifier] = value.value;
      }
      setFormData((prev) => ({ ...prev, ...newFormDataChanges }));
      setConfig(updatedConfig);
    } else {
      // Direct string value changes (e.g., text inputs)
      if (identifier === Step1QuestionIdConstants.QUESTION_17) {
        if (value.length <= 6) {
          setFormData((prev) => ({ ...prev, [identifier]: value }));
        }
      } else if (identifier === Step1QuestionIdConstants.QUESTION_18) {
        if (value.length <= 15) {
          setFormData((prev) => ({
            ...prev,
            [identifier]: value.replace(/[^a-zA-Z0-9 ]/g, "").toUpperCase(),
          }));
        }
      } else {
        setFormData((prev) => ({ ...prev, [identifier]: value }));
      }
    }
  };

  const validateFields = () => {
    const errors = {};
    config.forEach((field) => {
      const { identifier, isOptional } = field;
      if (
        !isOptional &&
        (!formData[identifier] || formData[identifier] === t("SELECT"))
      ) {
        errors[identifier] = true;
      }
    });
    setFieldErrors(errors);
    if (Object.keys(errors).length !== 0) {
      setShowError(true);
    }
    return Object.keys(errors).length === 0;
  };

  const close = () => {
    setReviewInfo(false);
  };

  const createPostBody = (selectedAnswers) => {
    let updatedPostBody = [];
    config.forEach((item) => {
       updatedPostBody.push({
        question_id: item.identifier,
        response: formData[item.identifier],
      });
    });
    ["bibhag_code", 'territory_code', 'upazila_code', 'zila_code'].map((item)=>{
      if(formData[item]){
        updatedPostBody.push({
        question_id: item,
        response: formData[item],
      });
      }
    })
    return updatedPostBody;
  };

  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  const saveProgresses = async () => {
    console.log(formData,'formData--------')
    let territoryID = await localStorage.getItem("territory_id");
    let userID = await localStorage.getItem("user_id");
    let brp_mobile_number = await localStorage.getItem("brp_mobile_number");
    let mobile_number = await localStorage.getItem("mobile_number");
    dispatch(setLoader(true));
    let PostBody = createPostBody(formData);
    const structured = {
      user_id: data.state.userID
        ? data.state.userID
        : data.state.parsedParameters
        ? data.state.parsedParameters.user_id
        : "",
      page_number: "page1",
      responses: PostBody,
      mobile_number: mobile_number,
      secondary_mobile_number: brp_mobile_number,
      action: "save",
    };
    const createUserdata = await getUserdata(formData);
    console.log("createUserdata --- ", createUserdata);
    const customer_id_stored = await localStorage.getItem("customer_id");
    if (createNewUser) {
      createUserdata['fo_id'] = userID;
      post("/customer", createUserdata)
        .then(async (response) => {
          if (response.customer_id) {
            setCreateNewUser(false);
            await localStorage.setItem("createnewuser", "false");
            await localStorage.setItem("customer_id", response.customer_id);
            structured["customer_id"] = response.customer_id;
            await post("/survey/save", structured)
              .then(async (response) => {
                dispatch(setLoader(false));
                window.alert(t("DATA_SAVED_SUCCESSFULLY"));
              })
              .catch((error) => {
                dispatch(setLoader(false));
                window.alert(t("SOMETHING_WENT_WRONG"));
                return;
              });
          }
        })
        .catch((error) => {
          console.log(error)
          navigate(`/?territory_id=${territoryID}&fo_id=${userID}`);
          dispatch(setLoader(false));
          window.alert(t("SOMETHING_WENT_WRONG"));
          return;
        });
      
    } else {
      if (customer_id_stored || data.state.retailer.customer_id) {
        structured["customer_id"] = customer_id_stored
          ? customer_id_stored
          : data.state.retailer.customer_id;
      }
      post("/survey/save", structured)
        .then(async (response) => {
          dispatch(setLoader(false));
          let updatedUserWithoutLocation = createUserdata;
          delete updatedUserWithoutLocation["territory_name"];
          delete updatedUserWithoutLocation["upazila_name"];
          delete updatedUserWithoutLocation["zila_name"];
          delete updatedUserWithoutLocation["territory_code"];
          delete updatedUserWithoutLocation["upazila_code"];
          delete updatedUserWithoutLocation["zila_code"];

          await fetch(`${API_URL}/customer/${structured["customer_id"]}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...updatedUserWithoutLocation,
              customer_id: structured["customer_id"],
            }),
          }).catch((error) => {
            window.alert(t("USER_UPDATION_FAILED"));
            return;
          });
          window.alert(t("DATA_SAVED_SUCCESSFULLY"));
        })
        .catch((error) => {
          console.log(error,'1')
          dispatch(setLoader(false));
          window.alert(t("SOMETHING_WENT_WRONG"));
          return;
        });
    }
  };

  let territoryID = localStorage.getItem("territory_id");
  const getUserdata = async (formData) => {
    let brp_mobile_number = await localStorage.getItem("brp_mobile_number");
    let mobile_number = await localStorage.getItem("mobile_number");
    return {
      customer_classification: formData[Step1QuestionIdConstants.QUESTION_8],
      customer_name: formData[Step1QuestionIdConstants.QUESTION_1],
      upazila_name: formData[Step1QuestionIdConstants.QUESTION_11], // Renamed
      shop_name: formData[Step1QuestionIdConstants.QUESTION_5],
      establishment_type: formData[Step1QuestionIdConstants.QUESTION_6],
      email_id: formData[Step1QuestionIdConstants.QUESTION_3],
      gstin: formData[Step1QuestionIdConstants.QUESTION_18],
      zila_name: formData[Step1QuestionIdConstants.QUESTION_10], // Renamed
      upazila_code: formData["upazila_code"], // Renamed
      zila_code: formData["zila_code"], // Renamed
      bibhag_name: formData[Step1QuestionIdConstants.QUESTION_9], // Renamed
      bibhag_code: formData["bibhag_code"], // Renamed
      mobile_number: mobile_number,
      secondary_mobile_number: brp_mobile_number,
      territory_code: formData["territory_code"],
      territory_name: formData[Step1QuestionIdConstants.QUESTION_15],
    };
  };

  const proceed = async () => {
    setReviewInfo(false);
    let brp_mobile_number = await localStorage.getItem("brp_mobile_number");
    let mobile_number = await localStorage.getItem("mobile_number");

    if (formData[Step1QuestionIdConstants.QUESTION_17]?.length !== 6) {
      window.alert(t("PIN_NUMBER_6_DIGIT"));
      return;
    }
    if (
      formData[Step1QuestionIdConstants.QUESTION_18] &&
      formData[Step1QuestionIdConstants.QUESTION_18].length !== 0 &&
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
        formData[Step1QuestionIdConstants.QUESTION_18]
      )
    ) {
      window.alert(t("INVALID_GST_NUMBER"));
      return;
    }
    dispatch(setLoader(true));
    let territoryID = await localStorage.getItem("territory_id");
    let userID = await localStorage.getItem("user_id");
    let PostBody = createPostBody(formData);
    const structured = {
      user_id: data.state.userID
        ? data.state.userID
        : data.state.parsedParameters
        ? data.state.parsedParameters.user_id
        : "",
      page_number: "page1",
      mobile_number: mobile_number,
      secondary_mobile_number: brp_mobile_number,
      responses: PostBody,
      action: "save_next",
    };
    const createUserdata = await getUserdata(formData);
    console.log(createUserdata, "--createUserdata--");
    const customer_id_stored = await localStorage.getItem("customer_id");

    if (data.state.retailer || customer_id_stored) {
      structured["customer_id"] = customer_id_stored
        ? customer_id_stored
        : data.state.retailer.customer_id;
    }

    if (createNewUser) {
      createUserdata['fo_id'] = userID;
      post("/customer", createUserdata)
        .then(async (response) => {
          console.log(response,'RESPONSE OF USER CREATION')
          if (response.customer_id) {
            setCreateNewUser(false);
            await localStorage.setItem("createnewuser", "false");
            structured["customer_id"] = response.customer_id;
            await localStorage.setItem("customer_id", response.customer_id);
            await post("/survey/save", structured)
              .then(async (response) => {
                dispatch(setLoader(false));
                navigate("/step2", {
                  state: {
                    parsedParameters: data.state.parsedParameters,
                    customerID: structured["customer_id"],
                    user_id: userID,
                    territory_id: territoryID,
                    bayerSeller: formData[Step1QuestionIdConstants.QUESTION_7],
                    customerType: formData[Step1QuestionIdConstants.QUESTION_8],
                  },
                });
              })
              .catch((error) => {
                console.log(error);
                dispatch(setLoader(false));
                window.alert(t("SOMETHING_WENT_WRONG") + "1");
                return;
              });
          }else{
            dispatch(setLoader(false));
            window.alert(response.message);
            return;
          }
        })
        .catch((error) => {
          console.log(error,'2')
          dispatch(setLoader(false));
          window.alert(t("SOMETHING_WENT_WRONG") + "2");
          return;
        });
     
    } else {
      if (customer_id_stored || (data.state.retailer && data.state.retailer.customer_id)) {
        structured["customer_id"] = customer_id_stored
          ? customer_id_stored
          : data.state.retailer.customer_id;
      }


      post("/survey/save", structured)
        .then(async (response) => {
          dispatch(setLoader(false));
          
           let updatedUserWithoutLocation = createUserdata;
          delete updatedUserWithoutLocation["territory_name"];
          delete updatedUserWithoutLocation["upazila_name"];
          delete updatedUserWithoutLocation["zila_name"];
          delete updatedUserWithoutLocation["territory_code"];
          delete updatedUserWithoutLocation["upazila_code"];
          delete updatedUserWithoutLocation["zila_code"];


          try {
            const response = await fetch(`${API_URL}/customer/${structured["customer_id"]}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ...updatedUserWithoutLocation,
                customer_id: structured["customer_id"],
              }),
            });
          
            if (!response.ok) {
              // If server returns error status
              window.alert(t("USER_UPDATION_FAILED"));
              return; // exit without navigating
            }
          
            // Only navigate if API call was successful
            navigate("/step2", {
              state: {
                parsedParameters: data.state.parsedParameters,
                customerID: structured["customer_id"],
                user_id: userID,
                territory_id: territoryID,
                bayerSeller: formData[Step1QuestionIdConstants.QUESTION_7],
                customerType: formData[Step1QuestionIdConstants.QUESTION_8],
              },
            });
          
          } catch (error) {
            // If fetch itself fails (network/server down)
            console.error("Fetch error:", error);
            window.alert(t("USER_UPDATION_FAILED"));
            return;
          }
          
        })
        .catch((error) => {
          dispatch(setLoader(false));
          window.alert(t("SOMETHING_WENT_WRONG"));
          console.error("Error fetching data:", error);
        });
    }
  };

  const moveToStep2 = () => {
    console.log("THIS ONE IS CLICKED")
    if (validateFields()) {
      if (
        formData[Step1QuestionIdConstants.QUESTION_22] === t("NO") &&
        formData[Step1QuestionIdConstants.QUESTION_23] === t("NO") &&
        formData[Step1QuestionIdConstants.QUESTION_24] === t("NO")
      ) {
        setshowSorryPup(true);
      } else {
        setReviewInfo(true);
      }
    }
  };

  const fetchRetailerDetails = async () => {
    if (!data.state.createNewUser) {
      setFormData((prev) => ({
        ...prev,
        [Step1QuestionIdConstants.QUESTION_5]: data.state.retailer.shop_name,
        [Step1QuestionIdConstants.QUESTION_2]: data.state.retailer.mobile_number,
      }));
    }
  };

  useEffect(() => {
    fetchRetailerDetails();
  }, []);

  const renderField = (field) => {
    const {
      type,
      fieldName,
      identifier,
      placeholder,
      options,
      isHalf,
      isFirst,
      autopopulateColumn,
      isOptional,
    } = field;

    const isDisabled =
      (identifier === Step1QuestionIdConstants.QUESTION_10 &&
        !enabledFields.zila) || // Zila disabled if no Bibhag selected
      (identifier === Step1QuestionIdConstants.QUESTION_11 &&
        !enabledFields.upazila) || // Upazila disabled if no Zila selected
      (identifier === Step1QuestionIdConstants.QUESTION_15 &&
        !enabledFields.territory); // Territory disabled if no Upazila selected or explicitly set to false for prefilled.

    const hasError = fieldErrors[identifier];

    switch (type) {
      case "text":
      case "date":
        return (
          <TextDate
            identifier={identifier}
            fieldName={t(fieldName)}
            type={type}
            placeholder={t(placeholder)}
            formData={formData}
            handleChange={handleChange}
            hasError={hasError}
            isOptional={isOptional}
            disabled={isDisabled}
          />
        );
      case "singleSelect":
        return (
          <SingleSelect
            identifier={identifier}
            isHalf={isHalf}
            isFirst={isFirst}
            fieldName={t(fieldName)}
            formData={formData}
            handleChange={handleChange}
            placeholder={t(placeholder)}
            // Options are already translated by the parent, but ensure consistency
            options={options}
            disabled={isDisabled}
            hasError={hasError}
            autopopulateColumn={autopopulateColumn}
            isOptional={isOptional}
          />
        );
      case "radio":
        return (
          <RadioControl
            identifier={identifier}
            fieldName={t(fieldName)}
            options={options.map((opt) => ({ ...opt, value: t(opt.value) }))}
            formData={formData}
            handleChange={handleChange}
            hasError={hasError}
            isOptional={isOptional}
          />
        );
      default:
        return null;
    }
  };

  const showSaveProgress = () => {
    setSaveProgress(true);
  };
  console.log(formData,'---')
  return (
    <div>
      {/* <div>
        <button onClick={() => setCurrentLanguage("en")}>English</button>
        <button onClick={() => setCurrentLanguage("bn")}>বাংলা</button>
      </div> */}
      {showError && (
        <InfoPopUp
          close={() => {
            setShowError(false);
          }}
          heading={t("UPDATE_MANDATORY_FIELDS")}
          text={t("PLEASE_UPDATE_ALL_MANDATORY")}
        />
      )}
      {Utils.loading && <LoaderFaded />}
      {saveProgress && (
        <SaveProgress
          close={() => {
            setSaveProgress(false);
          }}
          saveprogress={async () => {
            let territoryID = await localStorage.getItem("territory_id");
            let userID = await localStorage.getItem("user_id");
            saveProgresses();
            navigate(`/?territory_id=${territoryID}&fo_id=${userID}`);
          }}
        />
      )}
      {showSorryPup && (
        <HasLiscence
          SaveAndExit={() => {
            setshowSorryPup(false);
            let PostBody = createPostBody(formData);
            const structured = {
              user_id: data.state.userID
                ? data.state.userID
                : data.state.parsedParameters
                ? data.state.parsedParameters.user_id
                : "",
              page_number: "page1",
              responses: PostBody,
              action: "discontinue",
            };
            post("/survey/save", structured)
              .then((response) => {
                dispatch(setLoader(false));
                navigate(
                  `/?territory_id=${data.state.territoryID}&fo_id=${data.state.parsedParameters.user_id}`
                );
              })
              .catch((error) => {
                console.error("Error fetching data:", error);
              });
            navigate(
              `/?territory_id=${data.state.territoryID}&fo_id=${data.state.UserID}`
            );
          }}
          HaveLiscence={() => {
            setshowSorryPup(false);
          }}
        />
      )}
      {reviewInfo && <ProceedNotification close={close} proceed={proceed} />}
      <Header
        header={t("RETAILER_SURVEY")}
        subheader={t("STEP_1")}
        parsedParameters={data.state.parsedParameters}
        showSaveProgress={showSaveProgress}
      />
      <div style={Style.container}>
        {config.map((field) => renderField(field))}
      </div>
      {(formData.territory_name && formData.territory_name !== '' && formData.shop_name && formData.shop_name!=='') && 
      <SaveAndCont onContinue={moveToStep2} saveProgress={saveProgresses} />}
    </div>
  );
};
